import { IGetDataset } from "../../../models/IGetDataset";
import { IGetProject } from "../model";

export const DATASETTYPE = 'datasetType';
export const DATASETFORMAT = 'datasetFormat';

export const isDataset = (item: IGetDataset | IGetProject) => {
  return DATASETFORMAT in item;
};
